import styled from 'styled-components';
import Text from 'relements/build/esm/ui/text';

const homeStyle = (props) => ({
  color: props.theme.colors.grey.dark,
  ':hover': {
    color: props.theme.colors.blue.haptik,
    cursor: 'pointer',
  },
});

const nextPageStyle = (props) => ({
  color: props.theme.colors.black.haptik,
});

export const HomeText = styled(Text)(homeStyle);
export const NextPageText = styled(Text)(nextPageStyle);
